import { Injectable } from '@angular/core';
import { SiteCookies } from '@constants/global';
import { IUserResponse, IUserData, IUserInfo } from '@interfaces/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { UtilityService } from './utility.service';
import { CheckAppliedCouponDiscountResponse } from '@interfaces/cancelSubscription';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  userData$ = new BehaviorSubject<IUserData>({});
  userDetails: IUserData = {
    isLoggedIn : false
  };
  checkAppliedCouponDiscountObj!: CheckAppliedCouponDiscountResponse;

  constructor(private utility: UtilityService) { }

  setUserInfo(responseObj: IUserResponse){
    this.userDetails = {
      isLoggedIn : responseObj.response.isLoggedIn,
      siteInfo : responseObj.response.siteInfo,
      userInfo : responseObj.response.userInfo
    };
    this.userData$.next(this.userDetails);

    if(responseObj.response.token){
      this.utility.setCookie(SiteCookies.ACCESSTOKEN, responseObj.response.token);
    }
    if(responseObj.response.refresh_token){
      this.utility.setCookie(SiteCookies.REFRESHTOKEN, responseObj.response.refresh_token);
    }
  }

  updateUserInfo(key: keyof IUserInfo, value: string | number){
    if((value && this.userDetails.userInfo) || (value === 0 && this.userDetails.userInfo)){
      (this.userDetails.userInfo as any)[key] = value;
      this.userData$.next(this.userDetails);
    }
  }

  /* setUserData(userDetails: IUserData){
    this.userData$.next(userDetails);
  } */
  
  getUserInfo(){
    return this.userDetails;
  }

  isLoggedIn(){
    return this.userDetails.isLoggedIn;
  }

  getUserDataObservable(){
    return this.userData$.asObservable();
  }

  getUserLocation(){
    return {
      locationId: this.userDetails.siteInfo?.location_id,
      locationName: this.userDetails.siteInfo?.location_name
    }
  }

  deleteUserInfo(){
    this.userDetails = {
      isLoggedIn : false,
      siteInfo: this.userDetails.siteInfo,
      userInfo : null
    };
    this.userData$.next(this.userDetails);
  }

  getCancellationDiscountDetails(): Observable<CheckAppliedCouponDiscountResponse | null>{
    return new Observable((observer) => {
      const subs = { 
        next: (response: CheckAppliedCouponDiscountResponse) => {
          observer.next(response);
          observer.complete();
        },
        error: (e: any) =>{
          console.log(e);
          observer.next(null);
          observer.complete();
        }};
      this.utility.sendRequest<CheckAppliedCouponDiscountResponse>(environment.checkCouponDiscount).subscribe(subs);
    });
  }

}
